import FingerprintJS from "@fingerprintjs/fingerprintjs";

let deviceIdPromise: Promise<string> | null = null;

export const getDeviceId = (): Promise<string> => {
  if (!deviceIdPromise) {
    deviceIdPromise = FingerprintJS.load()
      .then((fp) => fp.get())
      .then((result) => result.visitorId)
      .catch((error) => {
        console.error("error generating device fingerprint", error);
        return "";
      });
  }
  return deviceIdPromise;
};
